var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from 'react';
export function useDigitsCodeInput(length) {
    var _a = useState(Array.from({ length: length }).fill('')), codeInArray = _a[0], setCodeInArray = _a[1];
    var _b = useState(0), focusIndex = _b[0], setFocusIndex = _b[1];
    var _c = useState(''), resultedCode = _c[0], setResultedCode = _c[1];
    useEffect(function () {
        for (var _i = 0, codeInArray_1 = codeInArray; _i < codeInArray_1.length; _i++) {
            var digit = codeInArray_1[_i];
            if (digit.length === 0 || Number.isNaN(Number.parseInt(digit))) {
                setResultedCode('');
                return;
            }
        }
        setResultedCode(codeInArray.join(''));
    }, [codeInArray]);
    function onChangeDigit(index, value) {
        var newValue = value.slice(-1);
        if (value.length > 0 &&
            value.length < length &&
            (Number.isNaN(Number.parseInt(newValue)) || index < 0 || index >= length)) {
            return;
        }
        if (value.length >= length) {
            var pastedCode = [];
            for (var i = 0; i < length; i++) {
                if (Number.isNaN(Number.parseInt(value[i])))
                    return;
                pastedCode.push(value[i]);
            }
            setCodeInArray(pastedCode);
            setFocusIndex(length - 1);
            return;
        }
        var copy = __spreadArray([], codeInArray, true);
        copy[index] = newValue;
        setCodeInArray(copy);
        setFocusIndex(value.length === 0 ? Math.max(0, index - 1) : Math.min(length - 1, index + 1));
    }
    return { codeInArray: codeInArray, focusIndex: focusIndex, resultedCode: resultedCode, setFocusIndex: setFocusIndex, onChangeDigit: onChangeDigit };
}
